import clsx from 'clsx';
import {
    BrandoramaProps,
    GlowBrandoramaBanner,
    GlowContainerSection,
    GlowHorizontalScrollContainer,
    PropsWithDataLayer,
} from '@headless-workspace/glow-ds';
import { Component } from '@headless-workspace/typings';

type UIBrandoramaContainerProps = PropsWithDataLayer & {
    title: string;
    subtitle: string;
    button: {
        label: string;
        href: string;
    };
    brandoramaTiles: BrandoramaProps[];
    className?: string;
    dataTestId: string;
};

export const UIBrandoramaContainer: Component<UIBrandoramaContainerProps> = ({
    title,
    subtitle,
    button,
    brandoramaTiles,
    dataLayer,
    className,
    dataTestId,
}) => (
    <GlowContainerSection
        title={title}
        subtitle={subtitle}
        button={button}
        className={clsx('gap-1.5 tablet:gap-2', className)}
        titleContainerClassName={'px-1 desktop:px-1.5'}
        dataLayer={dataLayer}
        dataTestId={dataTestId}
    >
        <GlowHorizontalScrollContainer className={'gap-1.5 desktopS:gap-1.25 justify-between'}>
            {brandoramaTiles.map((brandorama) => (
                <GlowBrandoramaBanner
                    className={clsx('first:pl-1 desktop:first:pl-1.5 last:pr-1 desktopS:last:pr-1.5 py-[0.125rem]')}
                    key={`brand-${brandorama.id}`}
                    {...brandorama}
                />
            ))}
        </GlowHorizontalScrollContainer>
    </GlowContainerSection>
);
